import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaLock } from 'react-icons/fa';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-red-100 p-4 rounded-full">
            <FaLock className="text-red-500 text-4xl" />
          </div>
        </div>
        
        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          Unauthorized Access
        </h1>
        
        <p className="text-gray-600 mb-8">
          Sorry, you don't have permission to access this page. Please contact your administrator if you believe this is a mistake.
        </p>

        <div className="space-y-4">
          <button
            onClick={() => navigate(-1)}
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors duration-200"
          >
            Go Back
          </button>
          
          <button
            onClick={() => navigate('/')}
            className="w-full bg-gray-200 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-300 transition-colors duration-200"
          >
            Return to Home
          </button>
        </div>

        {/* <div className="mt-8 text-sm text-gray-500">
          <p>Error Code: 403</p>
          <p className="mt-2">For assistance, please contact support</p>
        </div> */}
      </div>
    </div>
  );
};

export default Unauthorized;
